const parseToken = (token: string | null): any =>
  token ? JSON.parse(atob(token.split('.')[1])) : undefined;

export default parseToken;
